import http from '@/biz/http.mjs'

export default {
    read: ({pkid}) => http.get(`/archdms/${pkid}`),
}
